import { EXTENSIONS } from 'probonio-shared-ui/registry';
import { ExtensionBuilder } from 'probonio-shared-ui/registry/extension-definition';
import { BenefitActivationDialogExtensionInterface } from '../../../extension/interface/benefit-activation-dialog.extension.interface';
import { BenefitMetadataExtensionInterface } from '../../../extension/interface/benefit-metadata.extension.interface';
import { BenefitNavigationExtensionInterface } from '../../../extension/interface/benefit-navigation.extension.interface';
import { RoutesExtensionInterface } from '../../../extension/interface/routes.extension.interface';
import { CarBenefitActivationDialogExtension } from './extension/car-benefit-activation-dialog.extension';
import { CarBenefitMetadataExtension } from './extension/car-benefit-metadata.extension';
import { CarBenefitNavigationExtension } from './extension/car-benefit-navigation.extension';
import { CarRoutesExtension } from './extension/car-routes.extension';

EXTENSIONS.registerExtension(
  new ExtensionBuilder('car')
    .add(BenefitMetadataExtensionInterface, new CarBenefitMetadataExtension())
    .add(BenefitNavigationExtensionInterface, new CarBenefitNavigationExtension())
    .add(BenefitActivationDialogExtensionInterface, new CarBenefitActivationDialogExtension())
    .add(RoutesExtensionInterface, new CarRoutesExtension())
    .build(),
);
